import React from "react";
import {toast} from "react-toastify";

function renderPages(totalPages, actualPage, callBack) {
    const pages = [];

    const maxPages = totalPages <= 20 ? totalPages : 20;

    for (let i = 1; i <= maxPages; i++) {
        let page;

        if (i < 20) {
            page = <li key={i}>
                <button className={`page-button ${actualPage === i ? "page-button-active" : ""}`}
                        onClick={() => callBack(i)}>{i}</button>
            </li>;
        } else {
            page = <li key={i}>
                <button className={`page-button ${actualPage === i ? "page-button-active" : ""}`}
                        onClick={() => toast.info("Tente realizar uma busca...")}>...
                </button>
            </li>;
        }

        pages.push(page);
    }
    return pages;
}

function getNextPage(actualPage, totalPages) {
    const maxPage = totalPages < 20 ? totalPages : 19;
    const nextPage = actualPage + 1;

    if (nextPage <= maxPage) {
        return nextPage;
    } else {
        if (totalPages >= 20) {
            toast.info("Tente realizar uma busca...");
        }
        return maxPage;
    }
}

function getLastPage(actualPage) {
    const lastPage = actualPage - 1;
    return lastPage >= 1 ? lastPage : 1;
}

export default props => (
    <ul className="pagination">
        <li key={"last"} className="page-item"
            onClick={() => props.callBack(getLastPage(props.actualPage))}>
            <button className="page-button first-page-button">Anterior</button>
        </li>

        {renderPages(props.totalPages, props.actualPage, props.callBack)}

        <li key={"next"} className="page-item"
            onClick={() => props.callBack(getNextPage(props.actualPage, props.totalPages))}>
            <button className="page-button last-page-button">Próximo</button>
        </li>
    </ul>
)
